import classnames from 'classnames';
import React from 'react';

import { errorDetails, ErrorMessage } from './error_message';
import { AuthService, LoginWrapper } from '../../lib/login';

interface LoginContainerProps {
  google_client_id: string;
  authService: AuthService;
}

export const LoginContainer: React.FC<LoginContainerProps> = (props) => {
  return (
    <LoginWrapper {...props}>
      {({ loading, error, refLoginButton }) => (
        <div className="Login">
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
            {error !== undefined && <ErrorMessage {...errorDetails(error)} />}
            <div ref={refLoginButton} className={classnames({ loading })} />
          </div>
        </div>
      )}
    </LoginWrapper>
  );
};
